import type { FrontModule } from "@core/modules";
import "./location.css";
import { ApplicationPage } from "./application";
import { CampaignPage, CampaignsPage, NewCampaignPage, PropertyCampaignsTab } from "./campaigns";
import { MyApplicationPage, MyApplicationsPage } from "./candidate";
import { LocationDashboard } from "./dashboard";
import { ApplicantInvitationPage, PublicCampaignPage, ShortLinkPage } from "./public";

// Module « location » : campagnes, page et lien de candidature, visites, suivi et comparaison des candidatures,
// messages, candidats et garants, mesures (F-003, F-004, F-009 à F-014).
export const module: FrontModule = {
  name: "location",
  orgRoutes: [
    { path: "campagnes", element: <CampaignsPage /> },
    { path: "campagnes/nouvelle", element: <NewCampaignPage /> },
    { path: "campagnes/:campaignId", element: <CampaignPage /> },
    { path: "candidatures/:applicationId", element: <ApplicationPage /> },
  ],
  nav: [{ to: "campagnes", label: "Campagnes", section: "Location", perm: "read", order: 10 }],
  publicRoutes: [
    { path: "/candidature/invitation/:token", element: <ApplicantInvitationPage /> },
    { path: "/candidature/:slug", element: <PublicCampaignPage /> },
    { path: "/c/:code", element: <ShortLinkPage /> },
  ],
  accountRoutes: [
    { path: "/moi/candidatures", element: <MyApplicationsPage /> },
    { path: "/moi/candidatures/:applicationId", element: <MyApplicationPage /> },
  ],
  accountNav: [{ to: "/moi/candidatures", label: "Mes candidatures" }],
  Dashboard: LocationDashboard,
  propertyTabs: [{ id: "location-campagnes", label: "Campagnes", order: 30, Component: PropertyCampaignsTab }],
};
